import TutorRegistration from "../../Components/Authentication/TutorRegistration/TutorRegistration";
import { ROUTES } from "../Constants/Constants";
import OtpVerification from "../../Components/Authentication/OtpVerification/OtpVerification";
import Profile from "../../Components/Pages/ManageProfile/Profile/Profile";
import Login from "../../Components/Authentication/Login/Login";
import Dashboard from "../../Components/Pages/Dashboard/Dashboard";
import SignUp from "../../Components/Authentication/SignUp/SignUp";
import Registration from "../../Components/Authentication/Registration/Registration";
import ManageSessions from "../../Components/Pages/ManageSessions/SessionList/ManageSessions";
import CreateSessions from "../../Components/Pages/ManageSessions/CreateSessions/CreateSessions";
import SessionsDetail from "../../Components/Pages/ManageSessions/SessionsDetail/SessionsDetails";
import Onboarding from "../../Components/Pages/OnboardingScreen/OnboardingScreen";
import EditSessions from "../../Components/Pages/ManageSessions/EditSessions/EditSessions";
import WelcomeScreen from "../../Components/Pages/WelcomeScreen/WelcomeScreen";
import CalenderSession from "../../Components/Pages/ManageSessions/CalenderSession/CalenderSession";
import SchoolDetails from "../../Components/Pages/ManageSchools/SchoolDetails/SchoolDetails";
import EditSchools from "../../Components/Pages/ManageSchools/EditSchools/EditSchools";
import ViewUniversity from "../../Components/Pages/ManageUniversity/ViewUniversity/ViewUniversity";
import EditUniversity from "../../Components/Pages/ManageUniversity/EditUniversity/EditUniversity";
import BookingsList from "../../Components/Pages/ManageBookings/BookingsList/BookingsList";
import ViewBookings from "../../Components/Pages/ManageBookings/ViewBookings/ViewBookings";
import Notifications from "../../Components/Pages/Notifications/Notifications";
import ManageChat from "../../Components/Pages/ManageChat/ManageChat";
import BookingsListView from "../../Components/Pages/ManageBookings/BookingsListView/BookingsListView";
import DocumentsList from "../../Components/Pages/ManageDocuments/DocumentsList/DocumentsList";
import ManageCancelations from "../../Components/Pages/ManageCancelations/ManageCancelations";
import DiscountsList from "../../Components/Pages/ManageDiscounts/DiscountsList/DiscountsList";

const PublicRoutes = [
  {
    path: ROUTES.TUTOR_REGISTRATION,
    component: <TutorRegistration />,
  },
  {
    path: ROUTES.OTP_VERIFICATION,
    component: <OtpVerification />,
  },
  {
    path: ROUTES.LOGIN,
    component: <Login />,
  },
  {
    path: ROUTES.LOGIN_ERROR,
    component: <Login />,
  },
  {
    path: ROUTES.SIGN_UP,
    component: <SignUp />,
  },
  {
    path: ROUTES.REGISTER_SP,
    component: <Registration />,
  },
];
const PrivateRoutes = [
  {
    path: ROUTES.DASHBOARD,
    component: <Dashboard />,
  },
  {
    path: ROUTES.PROFILE,
    component: <Profile />,
  },
  {
    path: ROUTES.MANAGE_SCHOOLS,
    component: <SchoolDetails />,
  },
  {
    path: ROUTES.EDIT_SCHOOLS,
    component: <EditSchools />,
  },
  {
    path: ROUTES.MANAGE_SESSIONS,
    component: <CalenderSession />,
  },
  {
    path: ROUTES.MANAGE_UNIVERSITIES,
    component: <ViewUniversity />
  },
  {
    path: ROUTES.EDIT_UNIVERITY,
    component: <EditUniversity />
  },
  /*  {
     path: ROUTES.CREATE_SESSIONS,
     component: <CreateSessions />,
   }, */
  {
    path: ROUTES.EDIT_SESSIONS,
    component: <EditSessions />,
  },
  {
    path: ROUTES.VIEW_SESSIONS,
    component: <SessionsDetail />,
  },
  {
    path: ROUTES.ONBOARDING_SCREEN,
    component: <Onboarding />
  },
  {
    path: ROUTES.WELCOME_SCREEN,
    component: <WelcomeScreen />
  },
  {
    path: ROUTES.CREATE_SESSIONS,
    component: <CalenderSession />
  },
  {
    path: ROUTES.MANAGE_BOOKINGS,
    component: <BookingsList />
  },
  {
    path: ROUTES.VIEW_BOOKINGS,
    component: <ViewBookings />
  },
  {
    path: ROUTES.VIEW_BOOKINGS_LIST,
    component: <BookingsListView />
  },
  {
    path: ROUTES.NOTIFICATIONS,
    component: <Notifications />
  },
  {
    path: ROUTES.CHAT,
    component: <ManageChat />
  },
  {
    path: ROUTES.USER_CHAT,
    component: <ManageChat />
  },
  {
    path: ROUTES.MANAGE_DOCUMENTS,
    component: <DocumentsList />
  },
  {
    path: ROUTES.MANAGE_CANCELATIONS,
    component: <ManageCancelations />
  },
  {
    path: ROUTES.MANAGE_DISCOUNTS,
    component: <DiscountsList/>
  },
  /*   {
      path: ROUTES.REGISTER_SP,
      component: <Registration/>
    } */
];
export { PublicRoutes, PrivateRoutes };
